/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { defaultTo } from 'lodash';
import * as luxon from 'luxon';

export const convertToDateFormatUTC = (isoString: string): string => {
  return luxon.DateTime.fromISO(isoString).toUTC().toFormat('M/d/yyyy');
};

export const convertToDateFormat = (isoString: string): string => {
  return luxon.DateTime.fromISO(isoString).toFormat('M/d/yyyy');
};

export const getFormattedDisplay = (timestamp: number, format?: string) => {
  const dateLuxon = luxon.DateTime.fromMillis(timestamp);
  return dateLuxon.toFormat(defaultTo(format, 'MM/dd/yyyy hh:mm a'));
};

export const getDiffInUnits = (isoStringA: string, isoStringB: string, unit: luxon.DurationUnit): number => {
  const dateTimeA = luxon.DateTime.fromISO(isoStringA);
  const dateTimeB = luxon.DateTime.fromISO(isoStringB);
  const resultDuration = dateTimeA.diff(dateTimeB, unit);

  return resultDuration.get(unit);
};
